import React, {FC, useEffect, useState} from 'react';
import {useAppSelector} from 'redux/hooks';

import {t} from 'i18next';
import {addNewWarehouse, updateWarehouse,} from "../../../redux/warehouses/reducer";
import Tabs from "../../Tabs2";
import trashIcon from 'assets/images/trashBin.svg';
import {Button, Input} from "../../commons";
import {Field, withFormik} from "formik";
import Validations from "./Validations";
import store from "../../../redux/store";
import Radio from "../../commons/Input/Radio";
import {WarehouseType} from "../../../constants/Warehouses/WarehouseType";
import {Location} from "../../../constants/Warehouses/Location";
import DataSourcesWrapper from "./DataSourcesWrapper";
import {DataSource} from "../../../constants/DataSource/DataSource";
import {Supplier} from "../../../constants/Supplier/Supplier";
import warehousesService from "../../../api/services/warehousesService";
import structuredClone from '@ungap/structured-clone';
import Employees from "./Employees/Employees";
import {SupplierEmployee} from "../../../constants/Supplier/SupplierEmployee";
import {parseWarehouseType} from "../../Tables/WarehouseTable/parse-warehouse-type";
import Textarea from "../../commons/Input/Textarea";
import ToggleButton from "./ToggleButton";
import Number from "../../commons/Input/Number";
import FormSelect from "../../commons/Select/FormSelect";

const { List, Body, Tab, Panel }: any = Tabs;

interface WarehouseFormFields {
  uuid: string|null
  sellerID: number|null
  status: string
  name: string
  description: string
  address: string
  location: Location|null
  notice: string
  externalID: string
  externalService: string
  type: WarehouseType
  employees: SupplierEmployee[],
  dataSources: DataSource[],
  deliveryType: string|null,
  orderAssemblyTime: number|null,
  isForSale: boolean,
  isShowInStocksList: boolean,
  isEnabledAutoImportStocksByDS: boolean,
  isEnableExport: boolean,
  isEnableReserving: boolean,
  supplier: Supplier|null
}

interface WarehouseFormProps {
  values: WarehouseFormFields,
  touched: any,
  errors: any,
  isSubmitting: any,
  handleChange: any,
  handleBlur: any,
  handleSubmit: any,
  resetForm: any,
  setValues: any,
  setModalOpen: (param: boolean) => void,
  setFieldValue: any,
  isNeedClearWarehouseForm: boolean,
  setIsNeedClearWarehouseForm: (param: boolean) => void,
}

const initialFields: WarehouseFormFields = {
  uuid: null,
  sellerID: null,
  status: 'active',
  name: '',
  notice: '',
  description: '',
  address: '',
  location: null,
  externalID: '',
  externalService: '',
  type: WarehouseType.FBS,
  employees: [],
  dataSources: [],
  deliveryType: null,
  orderAssemblyTime: null,
  isShowInStocksList: true,
  isForSale: true,
  isEnabledAutoImportStocksByDS: false,
  isEnableExport: true,
  isEnableReserving: false,
  supplier: null,
}

const InnerFormWarehouse: FC<WarehouseFormProps> = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleChange,
  handleBlur,
  handleSubmit,
  resetForm,
  setValues,
  setModalOpen,
  setFieldValue,
  isNeedClearWarehouseForm,
  setIsNeedClearWarehouseForm
}) => {

  const {userId} = useAppSelector(({users}) => ({
    userId: users.currentUser.info.id
  }));

  const editingRow = useAppSelector((state) => state.warehouses.editingRow);
  const currentSeller = useAppSelector((state) => state.sellers.currentSeller);
  // @ts-ignore
  values.sellerID = currentSeller.info.data.id

  const [orderAssemblyTime, setOrderAssemblyTime] = useState<number|string>('')
  const [isSupplierType, setIsSupplierType] = useState<boolean>(false)
  const [dataSourceModel, setDataSourceModel] = useState<DataSource[]>([])
  const [employeesModel, setEmployeesModel] = useState<SupplierEmployee[]>([])
  const [supplierEmployeesModel, setSupplierEmployeesModel] = useState<SupplierEmployee[]>([])

  useEffect(() => {
    updateDataSourceInValues(dataSourceModel)
  }, [isSupplierType]);

  useEffect(() => {
    console.log(dataSourceModel)
  }, [dataSourceModel]);

  useEffect(() => {
    if (isNeedClearWarehouseForm) {
      resetForm()
      setDataSourceModel([])
      console.log('resetForm')
    }
  }, [isNeedClearWarehouseForm]);

  useEffect(() => {
    //
    setIsNeedClearWarehouseForm(false)

    //
    setIsSupplierType(values.type === WarehouseType.Supplier)

    //
    setOrderAssemblyTime(values.orderAssemblyTime ? values.orderAssemblyTime / 60 : '')

    console.log('values change', values)
  }, [values])

  useEffect(() => {
    if (!editingRow) {
      resetForm()
      return;
    }

    console.log('useEffect editingRow')
    warehousesService.getWarehouseByUUID(editingRow.id)
        .then(
            (res) => {
              if (res.data.success) {

                const resData = res.data.data
                const resDataCopy = structuredClone(resData)
                console.log('resData', resData)
                setValues(resDataCopy)
                values = resDataCopy
                console.log('values after populate', values)

                if (resData.type === WarehouseType.Supplier) {
                  if (resData.supplier?.dataSources?.length < 1) {
                    resData.supplier.dataSources = []
                  }
                  updateDataSourceModelHandler(resData.supplier?.dataSources || [])
                  if (resData.supplier?.employees?.length < 1) {
                    resData.supplier.employees = []
                  }
                  updateSupplierEmployeesModelHandler(resData.supplier?.employees || [])
                } else if (resData.dataSources?.length > 0) {
                  updateDataSourceModelHandler(resData.dataSources || [])
                } else {
                  updateDataSourceModelHandler([])
                }

                updateEmployeesModelHandler(resData.employees || [])
              }
              console.log(values)
            },
            (err) => {
              alert('Failed getting warehouse by uuid 1: ' + err.message())
            }
        )
        .catch((err) => {
          alert('Failed getting warehouse by uuid 2: ' + err.message)
        })
    ;
  }, [editingRow])

  useEffect(() => {
    setIsSupplierType(values.type === WarehouseType.Supplier)
  }, [])

  function updateDataSourceModelHandler(dataSourceModel: DataSource[]): void {
    setDataSourceModel(dataSourceModel)
    updateDataSourceInValues(dataSourceModel)
  }

  function setIsEnabledAutoImportStocksByDS(isEnabled: boolean): void {
    setFieldValue('isEnabledAutoImportStocksByDS', isEnabled)
  }

  function setIsEnableExport(isEnabled: boolean): void {
    setFieldValue('isEnableExport', isEnabled)
  }

  function setIsEnableReserving(isEnabled: boolean): void {
    setFieldValue('isEnableReserving', isEnabled)
  }

  function setIsForSale(isForSale: boolean): void {
    setFieldValue('isForSale', isForSale)
  }

  function setIsShowInStocksList(isShowInStocksList: boolean): void {
    setFieldValue('isShowInStocksList', isShowInStocksList)
  }

  function setLocationLatitude(latitude: number): void {
    setFieldValue('location', {latitude: latitude, longitude: values.location?.longitude})
  }

  function setLocationLongitude(longitude: number): void {
    setFieldValue('location', {latitude: values.location?.latitude, longitude: longitude})
  }

  function setDeliveryType(deliveryType: string): void {
    setFieldValue('deliveryType', deliveryType || null)
  }

  function orderAssemblyTimeChangeHandler(hours: string|undefined): void {
    setFieldValue('orderAssemblyTime', hours ? parseInt(hours) * 60 : null)
    setOrderAssemblyTime(hours ? parseInt(hours) : '')
  }

  function updateDataSourceInValues(dataSourceModel: DataSource[]): void {
    if (values.type === WarehouseType.Supplier) {
      if (!values.supplier) {
        values.supplier = {
          uuid: '',
          name: '',
          dataSources: [],
          employees: [],
        }
      }
      // @ts-ignore
      values.supplier.dataSources = dataSourceModel
      values.dataSources = []
      setFieldValue('dataSources', [])

    } else {
      setFieldValue('supplier', null)
      setFieldValue('dataSources', dataSourceModel)
    }
  }

  function updateEmployeesModelHandler(employeesModel: SupplierEmployee[]): void {
    setEmployeesModel(employeesModel)
    updateEmployeesInValues(employeesModel)
  }

  function updateEmployeesInValues(employeesModel: SupplierEmployee[]): void {
    // @ts-ignore
    values.employees = employeesModel
  }

  function updateSupplierEmployeesModelHandler(supplierEmployeesModel: SupplierEmployee[]): void {
    setSupplierEmployeesModel(supplierEmployeesModel)
    updateSupplierEmployeesInValues(supplierEmployeesModel)
  }

  function updateSupplierEmployeesInValues(supplierEmployeesModel: SupplierEmployee[]): void {
    if (values.type !== WarehouseType.Supplier) {
      return
    }

    if (!values.supplier) {
      values.supplier = {
        uuid: '',
        name: '',
        dataSources: [],
        employees: [],
      }
    }
    // @ts-ignore
    values.supplier.employees = supplierEmployeesModel
  }

  function handleDelete() {
    setFieldValue('status', 'deleted')
    handleSubmit()
  }

  function handleRepair() {
    setFieldValue('status', 'active')
    handleSubmit()
  }

  const isFBSWarehouse = [WarehouseType.FBS].includes(values.type)
  const isExternalWarehouse = [WarehouseType.ExternalWarehouseFBO,WarehouseType.ExternalWarehouseFBS].includes(values.type)
  const isSupportStockExport = [WarehouseType.ExternalWarehouseFBS, WarehouseType.PublicFBS].includes(values.type)
  const isIntegrationWarehouse = values.name === 'Интегрированный склад API LK'
  const isSupplierSellerWarehouse = values.externalID?.includes('se_spl')
  const isSupportDataSourceChange = [WarehouseType.FBS, WarehouseType.Supplier].includes(values.type) && !isIntegrationWarehouse && !isSupplierSellerWarehouse
  const isPublicWarehouse = values.type === WarehouseType.PublicFBS
  const isDeleted = values.status === 'deleted'

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
  return (
      // @ts-ignore
      <form onSubmit={handleSubmit} className="w-full">
        <div>
          <div style={{overflowWrap: 'anywhere'}}>
          </div>
          <div className="mb-4">
            <Input
                placeholder="Основной склад"
                id="name"
                name="name"
                value={values.name}
                label={t<string>("Наименование склада", {ns: "messages"})}
                changeHandler={handleChange}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={touched.name && errors && errors.name && errors.name.length > 0}
                validationErrorDescription={touched.name ? errors.name : ''}
                disabled={isDeleted || isExternalWarehouse || isIntegrationWarehouse}
            />
          </div>

          <div className="mb-4">
            <Input
                placeholder="Город, улица, номер здания"
                id="address"
                name="address"
                value={values.address}
                label={t<string>("Адрес склада", {ns: "messages"})}
                changeHandler={handleChange}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={touched.address && errors && errors.address && errors.address.length > 0}
                validationErrorDescription={touched.address ? errors.address : ''}
                require={false}
                disabled={isDeleted || isExternalWarehouse}
            />
          </div>

          <div className="mb-4 flex flex-row">
            <div className={`w-1/2`}>
              <Number
                  id="location_latitude"
                  name="location_latitude"
                  value={values.location?.latitude ? values.location.latitude : ''}
                  label={t<string>("Широта", {ns: "messages"})}
                  changeHandler={event => setLocationLatitude(parseFloat(event.target.value))}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={event => {
                    setLocationLatitude(parseFloat(event.target.value))
                    touched.location = true
                  }}
                  validationError={touched.location && errors && errors.location?.latitude && errors.location?.latitude?.length > 0}
                  validationErrorDescription={touched.location ? errors.location?.latitude : ''}
                  step={`any`}
                  min={0}
                  require={false}
              />
            </div>
            <div className={`p-4`}></div>
            <div className={`w-1/2`}>
              <Number
                  id="location_longitude"
                  name="location_longitude"
                  value={values.location?.longitude ? values.location.longitude : ''}
                  label={t<string>("Долгота", {ns: "messages"})}
                  changeHandler={event => setLocationLongitude(parseFloat(event.target.value))}
                  customClassName={customInputClassName}
                  customLabelClassName="text-sm"
                  blurHandler={event => {
                    setLocationLongitude(parseFloat(event.target.value))
                    touched.location = true
                  }}
                  validationError={touched.location && errors && errors.location?.longitude && errors.location?.longitude?.length > 0}
                  validationErrorDescription={touched.location ? errors.location?.longitude : ''}
                  step={`any`}
                  min={0}
                  require={false}
              />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-sm text-gray-600 text-left font-medium mb-1" htmlFor="warehouseType">
              Тип склада
            </label>
            <div>
              {!isExternalWarehouse &&
                  <Field component="div" name="warehouseType"
                         className="text-sm text-gray-600 flex justify-between items-center">
                    <div className="text-sm text-gray-600 text-left font-medium flex flex-col justify-between">
                      <div className={`flex mt-1`}>
                        <Radio
                            id="warehouseTypeFBS"
                            name="warehouseType"
                            value={WarehouseType.FBS}
                            label={parseWarehouseType(WarehouseType.FBS)}
                            changeHandler={(e) => values.type = e.target.value}
                            customLabelClassName="text-sm"
                            blurHandler={handleBlur}
                            checked={values.type === WarehouseType.FBS}
                            disabled={isDeleted}
                        />
                      </div>

                      <div className={`flex mt-1`}>
                        <Radio
                            id="warehouseTypeSupplier"
                            name="warehouseType"
                            value={WarehouseType.Supplier}
                            label={parseWarehouseType(WarehouseType.Supplier)}
                            changeHandler={(e) => values.type = e.target.value}
                            customLabelClassName="text-sm"
                            blurHandler={handleBlur}
                            checked={values.type === WarehouseType.Supplier}
                            disabled={isDeleted}
                        />
                      </div>

                      <div className={`flex mt-1`}>
                        <Radio
                            id="warehouseTypePublicFBS"
                            name="warehouseType"
                            value={WarehouseType.PublicFBS}
                            label={parseWarehouseType(WarehouseType.PublicFBS)}
                            changeHandler={(e) => values.type = e.target.value}
                            customLabelClassName="text-sm"
                            blurHandler={handleBlur}
                            checked={values.type === WarehouseType.PublicFBS}
                            disabled={isDeleted}
                        />
                      </div>

                    </div>
                  </Field>
              }

              {isExternalWarehouse &&
                  <Radio
                      id="warehouseTypeExternalFBS"
                      name="warehouseType"
                      value={values.type}
                      label={parseWarehouseType(values.type)}
                      customLabelClassName="text-sm whitespace-nowrap mt-1"
                      checked={true}
                      disabled={isDeleted || isExternalWarehouse}
                      changeHandler={() => {
                      }}
                  />
              }
            </div>
          </div>

          <div className="mb-4">

            <div className="mt-8">
              {!isExternalWarehouse && !isPublicWarehouse &&
                  <label className={`flex mt-3`}>
                    <ToggleButton
                        onChange={setIsForSale}
                        isChecked={values.isForSale}
                        disabled={isDeleted}
                    />
                    <span className={`pl-2 text-sm`}>Учитывать "К продаже"</span>
                  </label>
              }
              {isSupportStockExport &&
                  <label className={`flex mt-3`}>
                    <ToggleButton
                        onChange={setIsEnableExport}
                        isChecked={values.isEnableExport}
                        disabled={isDeleted}
                    />
                    <span className={`pl-2 text-sm`}>Показать во вкладке "Отправка"</span>
                  </label>
              }
              {!isIntegrationWarehouse && !isPublicWarehouse && !isSupplierSellerWarehouse &&
                  <>
                    <label className={`flex mt-3`}>
                      <ToggleButton
                          onChange={setIsEnabledAutoImportStocksByDS}
                          isChecked={values.isEnabledAutoImportStocksByDS}
                          disabled={isDeleted || isExternalWarehouse}
                      />
                      <span className={`pl-2 text-sm` + (isExternalWarehouse ? ' text-[#94A3B8]' : '')}>Загружать остатки из источника и отключить ручное изменение</span>
                    </label>
                  </>
              }
            </div>

            <DataSourcesWrapper
                data={dataSourceModel}
                updateDataHandler={updateDataSourceModelHandler}
                isSupportDataSourceChange={isSupportDataSourceChange}
                isIntegrationWarehouse={isIntegrationWarehouse}
                isPublicWarehouse={isPublicWarehouse}
                isSupplierSellerWarehouse={isSupplierSellerWarehouse}
                externalWhService={values.externalService}
                externalWhID={values.externalID}
                whID={values.uuid || ''}
            ></DataSourcesWrapper>

          </div>

          <div className="mb-4">
            <div className={'mb-4 text-[#1E293B] font-bold text-l w-full text-left'}>
              {t<string>("Описание", {ns: "messages"})}
            </div>
            <Textarea
                id="description"
                name="description"
                value={values.description}
                label={``}
                changeHandler={handleChange}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={touched.description && errors && errors.description && errors.description.length > 0}
                validationErrorDescription={touched.description ? errors.description : ''}
                require={false}
            />
          </div>

          <div className="mb-4 pt-5">
            <div className={'mb-4 text-[#1E293B] font-bold text-l w-full text-left'}>
              {t<string>("Заметки", {ns: "messages"})}
            </div>
            <Textarea
                id="notice"
                name="notice"
                value={values.notice}
                label={''}
                changeHandler={handleChange}
                customClassName={customInputClassName}
                customLabelClassName="text-sm"
                blurHandler={handleBlur}
                validationError={touched.notice && errors && errors.notice && errors.notice.length > 0}
                validationErrorDescription={touched.notice ? errors.notice : ''}
                require={false}
            />
          </div>

          {isFBSWarehouse && employeesModel && (
              <div className="mb-4">
                <Employees data={employeesModel} updateDataHandler={updateEmployeesModelHandler}></Employees>
              </div>
          )}

          {isSupplierType && supplierEmployeesModel && (
              <div className="mb-4">
                <Employees data={supplierEmployeesModel} updateDataHandler={updateSupplierEmployeesModelHandler}></Employees>
              </div>
          )}

          {isFBSWarehouse && (
              <div className="mb-4">
                <FormSelect
                    id={`deliveryType`}
                    name={`deliveryType`}
                    value={values.deliveryType || ''}
                    label={t<string>("Схема доставки", { ns: "messages" })}
                    changeHandler={event => setDeliveryType(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => setDeliveryType(event.target.value)}
                    validationError={false}
                    validationErrorDescription={''}
                    options={[
                      {text: '', value: ''},
                      {text: t<string>("Доставка до покупателя", { ns: "messages" }), value: 'delivery'},
                      {text: t<string>("Самовывоз из магазина", { ns: "messages" }), value: 'collect_by_customer'},
                    ]}
                    require={false}
                ></FormSelect>
              </div>
          )}

          {isFBSWarehouse && (
              <div className="mb-4">
                <Number
                    id={`orderAssemblyTime`}
                    name={`orderAssemblyTime`}
                    value={orderAssemblyTime}
                    label={t<string>("Время комплектации заказа, в часах", { ns: "messages" })}
                    changeHandler={event => orderAssemblyTimeChangeHandler(event.target.value)}
                    customClassName={customInputClassName}
                    customLabelClassName="text-sm"
                    blurHandler={event => orderAssemblyTimeChangeHandler(event.target.value)}
                    min={0}
                    step={1}
                    require={false}
                />
              </div>
          )}

          <div className="mb-[70px]">

            {editingRow &&
                <div className="delete-contacts border-t flex justify-end">
                  {!isDeleted &&
                      <button
                          className="flex-row items-center text-sm text-red-600 text-left font-medium mb-1 flex border-[1px] px-[15px] h-[38px] rounded mt-2 active:outline-none"
                          onClick={handleDelete}
                      >
                        <img src={trashIcon} className="mr-2"/>
                        <div>Отправить склад в архив</div>
                      </button>
                  }
                </div>
            }

          </div>

        </div>

        <div
            className="flex justify-center fixed bottom-0 border-t-[1px] px-3 w-full sm:w-1/3 sm:min-w-[511px] right-0 py-3 bg-white">
          {!isDeleted &&
              <Button
                  type="submit"
                  appearance="primary"
                  customClassName="w-full sm:w-5/6 py-2.5"
                  loading={isSubmitting}
              >
                {t<string>("Save settings", {ns: "messages"})}
              </Button>
          }

          {isDeleted &&
              <button
                  className="w-full sm:w-5/6 py-2.5 text-[#1f55a1] active:outline-none"
                  onClick={handleRepair}
              >
                <div>Восстановить склад</div>
              </button>
          }

          {/*<button*/}
          {/*    className="bg-blue w-5/6 py-2.5 text-white text-sm rounded text-[14px] font-medium"*/}
          {/*    type="submit"*/}
          {/*>*/}
          {/*  Сохранить настройки*/}
          {/*</button>*/}
        </div>
      </form>
  );
};

//@ts-ignore
const FormWarehouse = withFormik({
  enableReinitialize: true,

  mapPropsToValues: () => (initialFields),

  validate: (values: WarehouseFormFields, props) => {
    let errors = {};

    console.log('Validation', values)

    const validation = Validations();

    //@ts-ignore
    Object.keys(values).forEach((key) => validation[key] && validation[key](errors, values[key]))

    return errors;
  },

  handleSubmit: (values: WarehouseFormFields, { setSubmitting }) => {
    setSubmitting(true);
    setTimeout(() => {
      if(values.supplier) {
        values.supplier.name = values.name
      }
      console.log('Submission', values);

      if (values.uuid) {
        //@ts-ignore
        store.dispatch(updateWarehouse({uuid: values.uuid, data: values}))
      } else {
        //@ts-ignore
        store.dispatch(addNewWarehouse(values))
      }

      setSubmitting(false);
    }, 500)
  },
  //@ts-ignore
})(InnerFormWarehouse)

export default FormWarehouse;